"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFilter = exports.DataService = void 0;
/*
 *  Filename........: DataService.ts
 *  Project.........: logistik-app
 *  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
 *  @version........: 1.0
 *
 *  @since..........: 15.10.20, 09:26
 *  @author.........: robin
 *
 *  @brief..........:
 */
var axios_1 = __importDefault(require("axios"));
var DataService = /** @class */ (function () {
    function DataService(factory, modelPath, apiVersion, apiPath) {
        if (apiVersion === void 0) { apiVersion = 1; }
        if (apiPath === void 0) { apiPath = '/api/'; }
        this.apiPath = 'api/';
        this.apiVersion = 1;
        this.modelPath = '/';
        this.modelPath = modelPath;
        this.apiVersion = apiVersion;
        this.apiPath = apiPath;
        this.factory = factory;
    }
    DataService.prototype.getItems = function (page, itemsPerPage, sortBy, sortDesc, search, filter) {
        if (page === void 0) { page = 1; }
        if (itemsPerPage === void 0) { itemsPerPage = 10; }
        if (sortBy === void 0) { sortBy = 'id'; }
        if (sortDesc === void 0) { sortDesc = false; }
        if (search === void 0) { search = ''; }
        if (filter === void 0) { filter = []; }
        return __awaiter(this, void 0, void 0, function () {
            var params, response, items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            page: page,
                            itemsPerPage: itemsPerPage,
                            sortBy: sortBy,
                            sortDesc: sortDesc,
                            search: search,
                            filter: filter
                        };
                        return [4 /*yield*/, axios_1.default.post(this.getApiUrl() + '/get', params)];
                    case 1:
                        response = _a.sent();
                        items = response.data.data.map(this.factory);
                        return [2 /*return*/, {
                                'items': items,
                                'meta': response.data.meta
                            }];
                }
            });
        });
    };
    DataService.prototype.getAllItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.get(this.getApiUrl() + "/all")];
                    case 1:
                        response = _a.sent();
                        console.log(response);
                        return [2 /*return*/, response.data.data.map(this.factory)];
                }
            });
        });
    };
    DataService.prototype.create = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.post(this.getApiUrl(), { data: data })];
                    case 1:
                        response = _a.sent();
                        console.log(response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    DataService.prototype.getById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(this.getApiUrl() + '/' + id)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.factory(response.data.data)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, error_1.response];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DataService.prototype.update = function (id, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('whup');
                        return [4 /*yield*/, axios_1.default.put(this.getApiUrl() + '/' + id, { data: data })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DataService.prototype.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios_1.default.delete(this.getApiUrl() + '/' + id)];
            });
        });
    };
    DataService.prototype.massDelete = function (ids) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios_1.default.post(this.getApiUrl() + '/massDelete', { ids: ids })];
            });
        });
    };
    DataService.prototype.massUpdate = function (ids, updateValues) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios_1.default.post(this.getApiUrl())];
            });
        });
    };
    DataService.prototype.getApiUrl = function () {
        return this.apiPath + 'v' + this.apiVersion + '/' + this.modelPath;
    };
    return DataService;
}());
exports.DataService = DataService;
var SimpleFilter = /** @class */ (function () {
    function SimpleFilter(key, value) {
        this.key = '';
        this.value = '';
        this.key = key;
        this.value = value;
    }
    return SimpleFilter;
}());
exports.SimpleFilter = SimpleFilter;
